import { ConfigRepository } from './config.repository'
import { EnvValidateConfig } from './env-validate.config'

export const AppConfig = new ConfigRepository(EnvValidateConfig)

// validate() не вызывался нигде, поэтому отсутствующий REACT_APP_API_URI
// проявлялся только запросами на undefined. Падать в проде из-за этого не стоит,
// но в дев-режиме ошибку конфигурации нужно увидеть сразу.
const configErrors = AppConfig.validate()

if (configErrors.length) {
  const message = `Invalid environment config: ${ configErrors.join(', ') }`

  if (process.env.NODE_ENV === 'development') {
    throw new Error(message)
  }

  // eslint-disable-next-line no-console
  console.error(message)
}
